import angular from 'angular'

import { brandRoutes } from './brand.routes'

import { brandColorPaletteService } from './services/brand-color-palette.service'
import { brandFontsService } from './services/brand-fonts.service'
import { brandService } from './services/brand.service'

import { brandSection } from './directives/brand-section/brand-section.directive'
import { brandSectionAssetItem } from './directives/brand-section-asset-item/brand-section-asset-item.directive'
import { brandSectionFilesGroup } from './directives/brand-section-files-group/brand-section-files-group.directive'
import { brandSectionCategoryFormDialog } from './dialogs/brand-section-category-form/brand-section-category-form-dialog.directive'
import { brandSectionAssetFormDialog } from './dialogs/brand-section-asset-form/brand-section-asset-form-dialog.directive'
import { brandSectionFormDialog } from './dialogs/brand-section-form/brand-section-form-dialog.directive'

import { svgToolboxCustomerFontService } from './../editor/services/toolbox/svg-toolbox-fonts.service'

const module = angular
  .module('deskfy.brand', [])
  .config(brandRoutes)
  .factory('BrandColorPaletteService', brandColorPaletteService)
  .factory('BrandFontsService', brandFontsService)
  .factory('BrandService', brandService)
  .factory('SvgToolboxCustomerFontService', svgToolboxCustomerFontService)
  .directive('brandSection', brandSection)
  .directive('brandSectionAssetItem', brandSectionAssetItem)
  .directive('brandSectionFilesGroup', brandSectionFilesGroup)
  .directive('brandSectionAssetFormDialog', brandSectionAssetFormDialog)
  .directive('brandSectionCategoryFormDialog', brandSectionCategoryFormDialog)
  .directive('brandSectionFormDialog', brandSectionFormDialog)

export const brandModule = module
